/* __next_internal_client_entry_do_not_use__ default,KeyContactArticleClient auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { tv } from 'tailwind-variants';
import clsx from 'clsx';
import { useComponentProps } from '@sitecore-content-sdk/nextjs';
// Local
import { withStandardComponentWrapper } from 'helpers/HOC';
import { parseStyleParams } from 'lib/utils/style-param-utils';
import { getTestProps } from 'lib/testing/utils';
import { Default as KeyContacts } from './KeyContacts';
import useIsEditing from 'lib/hooks/useIsEditing';
import { EditingHelpText } from 'helpers/Editing/EditingHelpText';
import useDictionary from 'lib/hooks/useDictionary';
import { useSetIsDataAvailable } from 'lib/context/IsDataAvailableContext';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
const KeyContactWrapper = (props)=>{
    const { RenderingIdentifier } = props?.params || {};
    const styles = parseStyleParams(props.params, []);
    const isEditing = useIsEditing();
    const { getDictionaryValue } = useDictionary();
    const setIsDataAvailable = useSetIsDataAvailable();
    const ctxProps = useComponentProps(props?.rendering?.uid);
    const staticProps = props?.staticProps ?? ctxProps?.staticProps;
    const keyContact = staticProps?.keyContact;
    const secondaryKeyContact = staticProps?.secondaryKeyContact;
    const hasNoContacts = !keyContact && !secondaryKeyContact;
    useEffect(()=>{
        const available = !isEditing && !hasNoContacts;
        setIsDataAvailable(available);
    }, [
        hasNoContacts,
        isEditing,
        setIsDataAvailable
    ]);
    const { container, grid } = TAILWIND_VARIANTS();
    if (isEditing && hasNoContacts) {
        return /*#__PURE__*/ _jsx("section", {
            className: clsx(container(), styles),
            "data-component": "authorable/shared/content/keycontactwrapper",
            ...editingHydrationProps(isEditing),
            id: RenderingIdentifier,
            ...getTestProps(`key-contact-wrapper-${props?.rendering?.uid}`),
            children: /*#__PURE__*/ _jsx(EditingHelpText, {
                priority: "warning",
                children: getDictionaryValue('KeyContactWrapperHelpText') || 'Please select at least one Key Contact in the Content Editor (page item fields) to display contact information. Key Contacts cannot be set in the Page Editor.'
            })
        });
    }
    if (hasNoContacts) {
        return /*#__PURE__*/ _jsx(_Fragment, {});
    }
    return /*#__PURE__*/ _jsx("section", {
        className: clsx(container(), styles),
        "data-component": "authorable/shared/content/keycontactwrapper",
        ...editingHydrationProps(isEditing),
        id: RenderingIdentifier,
        ...getTestProps(`key-contact-wrapper-${props?.rendering?.uid}`),
        children: /*#__PURE__*/ _jsxs("div", {
            className: grid(),
            children: [
                keyContact && /*#__PURE__*/ _jsx(KeyContacts, {
                    fields: {
                        personData: keyContact
                    },
                    params: props.params,
                    rendering: props.rendering
                }),
                secondaryKeyContact && /*#__PURE__*/ _jsx(KeyContacts, {
                    fields: {
                        personData: secondaryKeyContact
                    },
                    params: props.params,
                    rendering: props.rendering
                })
            ]
        })
    });
};
const KeyContactArticleWrapper = (props)=>{
    const { RenderingIdentifier } = props?.params || {};
    const styles = parseStyleParams(props.params, []);
    const isEditing = useIsEditing();
    const { getDictionaryValue } = useDictionary();
    const setIsDataAvailable = useSetIsDataAvailable();
    const ctxArticleProps = useComponentProps(props?.rendering?.uid);
    const staticProps = props?.staticProps ?? ctxArticleProps?.staticProps;
    const authors = staticProps?.authors;
    const coAuthors = staticProps?.coAuthors;
    const hasNoContacts = !authors && !coAuthors || authors?.length === 0 && coAuthors?.length === 0;
    useEffect(()=>{
        const available = !isEditing && !hasNoContacts;
        setIsDataAvailable(available);
    }, [
        hasNoContacts,
        isEditing,
        setIsDataAvailable
    ]);
    const { container, grid } = TAILWIND_VARIANTS();
    if (isEditing && hasNoContacts) {
        return /*#__PURE__*/ _jsx("section", {
            className: clsx(container(), styles),
            "data-component": "authorable/shared/content/keycontactwrapper",
            ...editingHydrationProps(isEditing),
            id: RenderingIdentifier,
            ...getTestProps(`key-contact-wrapper-${props?.rendering?.uid}`),
            children: /*#__PURE__*/ _jsx(EditingHelpText, {
                priority: "warning",
                children: getDictionaryValue('KeyContactWrapperHelpText') || 'Please select at least one Key Contact in the Content Editor (page item fields) to display contact information. Key Contacts cannot be set in the Page Editor.'
            })
        });
    }
    if (hasNoContacts) {
        return /*#__PURE__*/ _jsx(_Fragment, {});
    }
    return /*#__PURE__*/ _jsx("section", {
        className: clsx(container(), styles),
        "data-component": "authorable/shared/content/keycontactwrapper",
        ...editingHydrationProps(isEditing),
        id: RenderingIdentifier,
        ...getTestProps(`key-contact-wrapper-${props?.rendering?.uid}`),
        children: /*#__PURE__*/ _jsxs("div", {
            className: grid(),
            children: [
                authors && authors.map((author)=>/*#__PURE__*/ _jsx(KeyContacts, {
                        fields: {
                            personData: author
                        },
                        params: props.params,
                        rendering: props.rendering
                    }, author.id)),
                coAuthors && coAuthors.map((coAuthor)=>/*#__PURE__*/ _jsx(KeyContacts, {
                        fields: {
                            personData: coAuthor
                        },
                        params: props.params,
                        rendering: props.rendering
                    }, coAuthor.id))
            ]
        })
    });
};
const TAILWIND_VARIANTS = tv({
    slots: {
        container: [
            'w-full'
        ],
        grid: [
            'grid',
            'grid-cols-1',
            'lg:grid-cols-3',
            'gap-spacing-spacing-24'
        ]
    }
});
export default withStandardComponentWrapper(KeyContactWrapper, false);
export const KeyContactArticleClient = withStandardComponentWrapper(KeyContactArticleWrapper, false);
